import { ethers } from 'ethers';

export function formatEth(value: bigint | string | number, decimals: number = 4): string {
  try {
    const wei = typeof value === 'bigint' ? value : BigInt(value as any);
    const eth = ethers.formatEther(wei);
    const [intPart, fracPart = ''] = eth.split('.');
    const trimmedFrac = fracPart.substring(0, decimals).padEnd(decimals, '0');
    return `${intPart}.${trimmedFrac} ETH`;
  } catch {
    try {
      // Fallback to string if not bigint-compatible
      const eth = typeof value === 'string' ? value : String(value);
      return `${eth} ETH`;
    } catch {
      return '0.0000 ETH';
    }
  }
}
